<template>
  <div class="box login">
    <!-- <div class="nav">
      <div class="head-content"
          style="display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 12px;
          ">
          <div style="display: flex; align-items: center;">
            <img :src="logoTitle.imgUrl" class="logo" width="200" height="50">
            <span style="font-size: 24px;">| &nbsp;{{ logoTitle.name }}</span>
          </div>
          <div @click="handleLogin" style="background-color: #368ee0; color: #fff; padding: 8px; cursor: pointer;">登录</div>
        </div>
    </div> -->
    <div class="head-mid clearfix">
      <img :src="logoTitle.imgUrl" class="logo">
      <span class="ptname">| &nbsp;{{ logoTitle.name }}</span>
      <div class="xzli qr-hover" @mouseover="show_qr">
        <img src="../../../assets/home_icon02.png" class="ticon">微信扫码访问
        <div class="qrcode" ref="qr_code">
          <img src="/wx-mp.png" style="width: 120px;height: 120px;">
          <!-- <vue-qr :text="h5Url" :margin="5" colorDark="#000" colorLight="#fff" :logoScale="0.3" :size="90"></vue-qr> -->
        </div>
      </div>
      <div class="xzli" @click="goAdmin">
        <img src="@/assets/desktop.png" class="ticon">
        <span>管理员访问入口</span>
      </div>
      <!-- <div class="xzli" v-b-modal.LoginForm v-if="!is_login">
        <img src="../../../assets/home_icon17.png" class="ticon">
        <span>登录</span>
      </div> -->
    </div>
    <div class="nav2" :class="{ 'is-absolute' : $route.path == '/pc/index' }" id="adult-style">
      <div class="nav-mid">
        <el-menu :default-active="$route.path" class="el-menu clearfix" mode="horizontal" text-color="#FFF" router>
          <el-menu-item class="el-menu-item" index="/pc/index">首页</el-menu-item>
          <el-menu-item class="el-menu-item" index="/pc/News">新闻资讯</el-menu-item>
          <!-- <el-menu-item class="el-menu-item" index="Download">APP下载</el-menu-item> -->
          <el-menu-item class="el-menu-item" index="/pc/Help">帮助中心</el-menu-item>
          <el-menu-item class="el-menu-item adult" index="/pc/Adult">
            <div></div>
            <div>备战成人高考</div>
            <div></div>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="login-bannerbox" v-if="$route.path == '/pc/index'">
      <img src="../../../assets/banner1.png" class="bannerbox-banner">
      <div class="loginBox" @keyup.enter="dologin">
        <div class="loginBox-title">
          <div class="title" :class="{'active': type == 0}" @click="typeChange(0)">学生登录</div>
          <!-- <div class="title" :class="{'active': type == 1}" @click="typeChange(1)">管理员登录</div> -->
        </div>
        <div class="loginBox-input clearfix">
          <img src="../../../assets/home_icon18.png" class="input-icon">
          <input type="text" class="ipt" placeholder="请输入账号" v-model="form.username"/>
        </div>
        <div class="loginBox-input clearfix">
          <img src="../../../assets/home_icon19.png" class="input-icon">
          <input type="password" class="ipt" placeholder="请输入密码" v-model="form.password"/>
        </div>
        <button class="loginBox-loginbtn" @click="dologin">登录</button>
      </div>
    </div>

    <login-form ref="LoginForm"></login-form>

    <el-dialog
      :visible.sync="showModal"
      title="登录"
      draggable
      width="30%"
      :z-index="100"
      :mask-closable="false"
    >
      <div class="modal-top-advert" style="text-align: center;">
        <el-tabs>
          <el-tab-pane key="1" label="学生"></el-tab-pane>
          <el-tab-pane key="2" label="教师"></el-tab-pane>
          <el-tab-pane key="3" label="管理员"></el-tab-pane>
        </el-tabs>
        <el-form
          ref="usernameLoginForm"
          :model="form"
          class="form"
        >
          <el-form-item prop="username">
            <el-input
              v-model="form.username"
              prefix="ios-contact"
              size="large"
              clearable
              placeholder="请输入用户名"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="form.password"
              prefix="ios-lock"
              size="large"
              password
              placeholder="请输入密码"
              autocomplete="off"
            />
          </el-form-item>
        </el-form>

        <el-button
          class="login-btn"
          type="primary"
          size="large"
          style="background-color: #368ee0; border-color: #368ee0;"
          :loading="loading"
          @click="submitLogin"
          long
        >
          <span>登录</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";
import {dologin} from "@/api";

// import storage from '@/plugins/storage.js';
// import { cartGoodsAll } from '@/api/cart.js';
// import { logout } from '@/api/account.js';
export default {
  name: 'M-Header',
  components: {LoginForm},
  created() {
    // if (localStorage.getItem('logoTitle')) {
    //   this.logoTitle = JSON.parse(localStorage.getItem('logoTitle'));
    // }
    // this.logoTitle = this.$store.state.logoTitle
  },

  data() {
    return {
      userInfo: {}, // 用户信息
      shoppingCart: [], // 购物车
      showModal: false,
      form: {},
      // logoTitle: {
      //   imgUrl: '',
      //   name: ''
      // },
      type: 0
    };
  },
  computed: {
    // 购物车商品数量
    cartNum() {
      return this.$store.state.cartNum;
    },
    logoTitle() {
      return this.$store.state.logoTitle
    }
  },
  methods: {
    goAdmin() {
      window.open(process.env.VUE_APP_MANAGEMENT_SYSTEM)
    },
    typeChange(type) {
      console.log(type);
      this.type = type
      console.log(this.type);
      // this.form = {
      //   username: null,
      //   password: null,
      // }
    },
    dologin() {
      if (this.type == 1) {
        this.admLogin()
      } else {
        this.stuLogin()
      }
    },
    // 学生登录
    async stuLogin() {
      if (!this.form.username) {
        this.$bvToast.toast("用户名不能为空", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if (!this.form.password) {
        this.$bvToast.toast("密码不能为空", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
        return;
      }
      dologin(this.form).then(async (res1) => {
        const res = await this.axios.post("/student/login");
        this.user = res.data
        this.$store.commit("LOGIN", this.user);
        const info = await this.axios.get("/student/info");
        if (info.data.length > 0) {
          this.$store.commit("LOGINBAK", info.data);
          if (info.data && info.data.length > 1) {
            this.$refs.SelectMajor.open((e) => {
              this.goHome(e);
            }, true);
          } else {
            this.goHome(info.data[0]);
          }
        } else {
          this.$router.push({path: "/main/readyExam"});
        }
      }).catch((err) => {
        this.$bvToast.toast("登陆失败，用户名或密码错误", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
      });
    },
    // // 管理员登录
    // async admLogin () {
    //   if (!this.form.username) {
    //     this.$bvToast.toast("用户名不能为空", {
    //       title: "提示",
    //       variant: "danger",
    //       solid: true,
    //     });
    //     return;
    //   }
    //   if (!this.form.password) {
    //     this.$bvToast.toast("密码不能为空", {
    //       title: "提示",
    //       variant: "danger",
    //       solid: true,
    //     });
    //     return;
    //   }
    //   await this.axios.post("/portal/admin/login", this.form)
    //     .then((res) => {
    //       let username = window.btoa(window.btoa(this.form.username)); // 编码
    //       let password = window.btoa(window.btoa(this.form.password)); // 编码
    //       window.location.href = `${process.env.VUE_APP_MANAGEMENT_SYSTEM}?u_=${username}&p_=${password}`
    //     })
    // },
    show_qr() {
      if (this.$refs.qr_code.style.display == 'block') {
        this.$refs.qr_code.style.display = 'none'
      } else {
        this.$refs.qr_code.style.display = 'block'
      }
    },
    submitLogin() {
      this.showModal = false;
    },
    handleLogin() {
      this.showModal = true;
    },
    goToPay() { // 跳转购物车
      let url = this.$router.resolve({
        path: '/cart'
      });
      window.open(url.href, '_blank');
    },
    myInfo() { // 跳转会员中心
      let url = this.$router.resolve({
        path: '/home'
      });
      window.open(url.href, '_blank');
    },
    signOutFun() { // 退出登录
      // logout().then(res => {
      //   // storage.removeItem('accessToken');
      //   // storage.removeItem('refreshToken');
      //   // storage.removeItem('userInfo');
      //   // storage.removeItem('cartNum');
      //   this.$store.commit('SET_CARTNUM', 0)
      //   this.$router.push('/login');
      // });
    },
    goUserCenter(path) {
      // 跳转我的订单，我的足迹、收藏等
      if (this.userInfo.username) {
        this.$router.push({path: path});
      } else {
        this.$Modal.confirm({
          title: '请登录',
          content: '<p>请登录后执行此操作</p>',
          okText: '立即登录',
          cancelText: '继续浏览',
          onOk: () => {
            this.$router.push({
              path: '/login',
              query: {
                rePath: this.$router.history.current.path,
                query: JSON.stringify(this.$router.history.current.query)
              }
            });
          }
        });
      }
    },
    shopEntry() {
      // 店铺入驻
      // if (storage.getItem('accessToken')) {
      //   let routeUrl = this.$router.resolve({
      //     path: '/shopEntry',
      //     query: { id: 1 }
      //   });
      //   window.open(routeUrl.href, '_blank');
      // } else {
      //   this.$router.push('login');
      // }
    },
    getCartList() {
      // 获取购物车列表
      if (this.userInfo.username) {
        // cartGoodsAll().then((res) => {
        //   this.shoppingCart = res.result.skuList;
        //   this.$store.commit('SET_CARTNUM', this.shoppingCart.length);
        //   this.Cookies.setItem('cartNum', this.shoppingCart.length);
        // });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.head-mid {
  width: 1200px;
  margin: 0 auto;

  .logo {
    float: left;
    height: 48px;
    margin: 26px 0;
    margin-right: 20px;
  }

  .ptname {
    float: left;
    font-size: 24px;
    color: #093151;
    line-height: 100px;
    display: block;
  }

  .xzli {
    float: right;
    font-size: 16px;
    color: #333333;
    line-height: 30px;
    margin: 35px 0 35px 50px;
    cursor: pointer;
    position: relative;

    .ticon {
      display: inline-block;
      vertical-align: middle;
      margin-bottom: 2px;
      margin-right: 5px;
    }

    .qrcode {
      display: none;
      position: absolute;
      top: 35px;
      right: -12px;
      z-index: 22;
    }
  }
}

.login-bannerbox {
  .loginBox {
    .loginBox-loginbtn {
      background-color: #3a77a8;
      border-radius: 5px;
      width: 100%;
      height: 38px;
      border: none;
      outline: none;
      cursor: pointer;
      color: #ffffff;
      font-size: 14px;
    }
  }
}


.shopping-cart-detail,
.shopping-cart-text,
.shopping-cart-info,
.nav a,
.location,
.first,
.username,
.shopping-cart-null span {

}

.box {
  position: relative;
  background: url("../../../assets/home_icon01.png") no-repeat;
  background-size: 100%;

  background-color: #fff;
  width: 100%;
  font-size: 12px !important;
  // height: 35px;
  // @include background_color($light_white_background_color);
}

.nav {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.nav ul {
  list-style: none;
}

.nav li {
  float: left;
  font-size: 12px;
  line-height: 35px;
  margin-right: 10px;
  font-weight: bold;
}

.nav a,
.nav-item {
  text-decoration: none;
  padding-left: 14px;
  border-left: 1px solid #ccc;
  color: #999;
  cursor: pointer;
}

.location a {
  border-left: none;
}

.nav a:hover {
  color: #3c8dbc;
}

.icon {
  color: gray;
  vertical-align: middle;
}

.first a:first-child {
  padding-left: 3px;
  border-left: none;
}

.city {
  padding: 10px 15px;
}

.city-item {
  font-weight: bold;
  cursor: pointer;
  padding: 5px;
}

.city-item:hover {
  color: #3c8dbc;
}

.person-icon {
  color: #3c8dbc;
  background-color: #f0cdb2;
}

.shopping-cart-list {
  padding: 10px 15px;
  box-sizing: border-box;
  max-height: 300px;
  overflow: scroll;
}

.shopping-cart-box {
  margin: 8px 0px;
  margin-top: 15px;
  padding-bottom: 15px;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px #ccc dotted;
}

.shopping-cart-box:first-child {
  margin-top: 8px;
}

.shopping-cart-img {
  margin-right: 15px;
  width: 40px;
  height: 40px;
}

.shopping-cart-img img {
  width: 100%;
}

.shopping-cart-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
  width: 200px;
  overflow: hidden;
  font-size: 12px;
  line-height: 20px;
}

.go-to-buy {
  display: flex;
  justify-content: flex-end;
}

.shopping-cart-null {
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cart-null-icon {
  font-size: 38px;
  margin-bottom: 15px;
}

.shopping-cart-null span {
  font-size: 12px;
  line-height: 16px;
}

.username-p {
  position: relative;

  div {
    cursor: pointer;

    > span {
      margin-left: 5px;
    }
  }

  .drop-items {
    position: absolute;
    display: none;
    top: 45px;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 5px 10px;
    z-index: 20;
    height: 150px;
    background-color: #fff;
    width: 80px;
    border: 1px solid #eee;
    box-shadow: 2px 2px 7px #999;

    li {
      color: rgb(107, 106, 106);
      width: 100%;
      border-bottom: 1px solid rgb(207, 206, 206);
      font-weight: normal;
      text-align: center;

      &:last-child {
        border: none;
      }

      &:hover {
        cursor: pointer;
        color: #3c8dbc;
      }
    }

    &::before {
      position: absolute;
      top: -20px;
      left: 30px;
      content: '';
      width: 0;
      height: 0;
      border: 10px solid #999;
      border-color: transparent transparent #fff transparent;
    }

    &::after {
      content: '';
      position: absolute;
      width: 80px;
      height: 20px;
      top: -20px;
      left: 0;
    }
  }

  &:hover {
    .drop-items {
      display: block;
    }
  }
}

.my-page {
  padding: 3px 5px;
  width: 180px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.my-page a {
  margin: 0px;
  padding: 0px;
  border: none;
}

.my-info {
  padding: 5px;
  width: 50%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}

.my-info:hover {
  box-shadow: 0px 0px 5px #ccc;
}

.my-info i {
  font-size: 28px;
}

.my-info p {
  font-size: 12px;
}

.sign-out {
  padding: 5px;
  width: 50%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}

.sign-out:hover {
  box-shadow: 0px 0px 5px #3c8dbc;
}

.sign-out i {
  font-size: 28px;
}

.sign-out p {
  font-size: 12px;
}

.goods-title:hover {
  color: #3c8dbc;
}

.cart-badge {
  position: absolute;
  right: -8px;
  font-style: normal;
  background-color: #3c8dbc;
  color: #fff;
  font-size: 12px;
  width: 17px;
  height: 17px;
  border-radius: 10px;
  line-height: 17px;
  text-align: center;
  z-index: 3;
  top: 3px;
}

.is-absolute {
  position: absolute;
}

.nav2 {
  width: 100%;
  background-color: rgba(25, 101, 162, 0.6);
  // position: absolute;
  top: 100px;
  left: 0;
  z-index: 1;

  .nav-mid {
    width: 1200px;
    margin: 0 auto;
    background: transparent;

    .el-menu {
      background: transparent;
      border-bottom: none;

      .el-menu-item {
        width: 150px;
        text-align: center;
      }

      .el-menu-item:hover {
        background: transparent;
      }

      .el-menu-item.is-active {
        border-bottom: none;
        color: #1965a2;
        background-color: #eef6ff;
      }

      .adult.is-active {
        background-color: transparent;

        :nth-child(1) {
          width: 60px;
          background: linear-gradient(-45deg, #d7e7f4 50%, transparent 50%);
        }

        :nth-child(2) {
          background-color: #d7e7f4;
        }

        :nth-child(3) {
          width: 60px;
          background: linear-gradient(135deg, #d7e7f4 50%, transparent 50%);
        }
      }

      .adult {
        display: flex;
        padding: 0;
        width: 276px;
        border: none;
        font-size: 26px;
        font-weight: bold;
        margin-left: 60px;

        :nth-child(1) {
          width: 60px;
          background: linear-gradient(-45deg, #ffa400 50%, transparent 50%);
        }

        :nth-child(2) {
          background-color: #ffa400;
        }

        :nth-child(3) {
          width: 60px;
          background: linear-gradient(135deg, #ffa400 50%, transparent 50%);
        }
      }
    }
  }
}
</style>
